import { Card ,Row,Col, Divider, Typography, message, Space,Form,Select,DatePicker,Button} from "antd";
import React, { Component } from "react";
import Chart from "react-apexcharts";
import storage from "../../utils/storage";
import { configs } from "../../config/config";
import { getActivationList, getActivationSum } from "../../model/dashboard/requests";
import { defaultStroke } from "../../model/dashboard/datasource";
import { formatDateString } from "../../utils/utils";
import { getGroup } from "../../model/group/requests";
const {Title} = Typography
const {Option} = Select;
const  {RangePicker} = DatePicker;

class DashBoardActivation extends Component {
    constructor(props){
        super(props)
        this.state = {
          options_chart1:{},
          series_chart1:[],
          options_chart2:{},
          series_chart2:[],
          customList:[],
          filterCustom:0,
          filterDate:[]
        }      
        
    }

    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    componentDidMount(){
      let options_chart1 = {
        title: {
          text: 'Daily New Activitions',
          align: 'left'
        },
        stroke: defaultStroke,
        xaxis: {
          tickPlacement: 'between',
        },
      }

      let  options_chart2 = {
        title: {
          text: 'Total',
          align: 'left'
        },
        stroke: {
          show: true,
          curve: 'straight',
          lineCap: 'butt',
          colors: "#62d3ca",
          width: 3,
          dashArray: 0, 
        },
        xaxis: {
          tickPlacement: 'between',
        }
      }

      let series_chart1 = []
      let categories_chart1 = []

      let series_chart2 = []
      let categories_chart2 = []


     // 获取activation_date group by cid
      getActivationList({start:"",end:"",custom_id:0}).then(res=>{
        if (res.data.code === 200){
           let ret = res.data.data
           let _category = []
           let _data = []
            for (let i =0;i<ret.length;i++){
              let _date = formatDateString(ret[i].activation_date)
                _category.push(_date)
                _data.push(ret[i].nums)
            }
            let _series_data = {}
            _series_data.data = _data        
            _series_data.name = "Activation" 
            series_chart1.push(_series_data)
            if(categories_chart1.length <= 0 ){
              categories_chart1.push(..._category)
          }
        }
      }).catch(err=>{
        message.error(err)
      }) 

      getActivationSum({start:"",end:"",custom_id:0}).then(res=>{
        if (res.data.code === 200){
           let ret = res.data.data
           let _category = []
           let _data = []
            for (let i =0;i<ret.length;i++){
               let _date = formatDateString(ret[i].activation_date)
                _category.push(_date)
                _data.push(ret[i].nums)
            }
            let _series_data = {}
            _series_data.data = _data        
            _series_data.name = "Total" 
            series_chart2.push(_series_data)
            if(categories_chart2.length <= 0 ){
              categories_chart2.push(..._category)
          }
        }
      }).catch(err=>{
        message.error(err)
      }) 
      

      let data = storage.get(configs.cache.tokenKey)
      let group_id = data.group_id
      let customList = [];
      getGroup({id:group_id}).then(res=>{
          if(res.data.code == 200){
              customList = res.data.data.customs
          }else{
              message.error(res.data.msg)
          }

      }).catch(err=>{
          message.error(err)
      })

      setTimeout(() => {
        options_chart1.xaxis.categories = [...categories_chart1]
        options_chart2.xaxis.categories = [...categories_chart2]
        this.setState({
          options_chart1:options_chart1,
          series_chart1:series_chart1,
          options_chart2:options_chart2,
          series_chart2:series_chart2,
          customList:customList
       
        })

      }, 500);


    }

    handlerCustomChange = (item)=>{
      this.setState({
          filterCustom:item.value
      })
    }
    handlerDateChange = (date,dtString) =>{
        console.log(dtString)
        this.setState({
            filterDate:dtString
        })
    }

  handlerSearch =()=>{
    let custom = this.state.filterCustom
    let start = this.state.filterDate.length ==2 ? this.state.filterDate[0] : "";
    let end = this.state.filterDate.length ==2 ? this.state.filterDate[1] : "";
    let options_chart1 = {
      title: {
        text: 'Daily New Activitions',
        align: 'left'
      },
      stroke: defaultStroke,
      xaxis: {
        tickPlacement: 'between',
      },
    }

    let  options_chart2 = {
      title: {
        text: 'Total',
        align: 'left'
      },
      stroke: {
        show: true,
        curve: 'straight',
        lineCap: 'butt',
        colors: "#62d3ca",
        width: 3,
        dashArray: 0, 
      },
      xaxis: {
        tickPlacement: 'between',
      }
    }

    let series_chart1 = []
    let categories_chart1 = []

    let series_chart2 = []
    let categories_chart2 = []
    getActivationList({start:start,end:end,custom_id:custom}).then(res=>{
      if (res.data.code === 200){
         let ret = res.data.data
         let _category = []
         let _data = []
          for (let i =0;i<ret.length;i++){
            let _date = formatDateString(ret[i].activation_date)
              _category.push(_date)
              _data.push(ret[i].nums)
          }
          let _series_data = {}
          _series_data.data = _data        
          _series_data.name = "Activation" 
          series_chart1.push(_series_data)
          if(categories_chart1.length <= 0 ){
            categories_chart1.push(..._category)
        }
      }
    }).catch(err=>{
      message.error(err)
    }) 

    getActivationSum({start:start,end:end,custom_id:custom}).then(res=>{
      if (res.data.code === 200){
         let ret = res.data.data
         let _category = []
         let _data = []
          for (let i =0;i<ret.length;i++){
             let _date = formatDateString(ret[i].activation_date)
              _category.push(_date)
              _data.push(ret[i].nums)
          }
          let _series_data = {}
          _series_data.data = _data        
          _series_data.name = "Total" 
          series_chart2.push(_series_data)
          if(categories_chart2.length <= 0 ){
            categories_chart2.push(..._category)
        }
      }
    }).catch(err=>{
      message.error(err)
    }) 


    setTimeout(() => {
      options_chart1.xaxis.categories = [...categories_chart1]
      options_chart2.xaxis.categories = [...categories_chart2]
      this.setState({
        options_chart1:options_chart1,
        series_chart1:series_chart1,
        options_chart2:options_chart2,
        series_chart2:series_chart2
      })

    }, 500);




  }
    render(){
      const {customList} = this.state;
        return(
            <>
            <Title>Activation</Title>
            <Row gutter={[24, 0]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                <Card bordered={false} className="criclebox h-full">
                <Chart
                    options={this.state.options_chart1}
                    series={this.state.series_chart1}
                    type="line"
                    width="100%"
                    height={"500px"}
                />
                </Card>
              </Col>
            </Row>
            <Space />
            <Divider />
            <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
                <Card bordered={false} className="criclebox h-full">
                <Chart
                    options={this.state.options_chart2}
                    series={this.state.series_chart2}
                    type="line"
                    width="100%"
                    height={"500px"}
                />
                </Card>
              </Col>
            </Row>
            <Divider />
            <Form  name="horizontal_login" layout="inline"  ref={this.formRef} >
                <Form.Item
                    name="date"
                >
                <RangePicker 
                    onChange={this.handlerDateChange}
                    format="YYYY-MM-DD" />
                </Form.Item>

                    <Form.Item name={'name'}>
                        <Select 
                         placeholder={"Please Chosen a Custom  Id"}
                         onChange={this.handlerCustomChange}
                         labelInValue
                        >
                          <Option key={0} value={0} >
                            All
                          </Option>
                        {customList.length > 0  && customList.map((items) => {
                                return (<Option key={items.id} value={items.id}>{items.name}</Option>)
                        })}

                        </Select>
                    </Form.Item> 
                    <Form.Item shouldUpdate>
       
                    <Button
                        type="primary"
                        style={{background: "#851dd6" }}
                        onClick={this.handlerSearch}
                    >
                       Filter
                    </Button>
     
                    </Form.Item>
            </Form> 
            </>
        )
    }
}

export default DashBoardActivation;
